import { createContext } from 'react';

export interface PermissionFlags {
  master: boolean;
  owner: boolean;
  admin: boolean;
  developer: boolean;
  editor: boolean;
  viewer: boolean;
  support: boolean;
  dev: boolean;
  user: boolean;
}

export interface AuthSession {
  id?: string;
  activeOrganizationId?: string | null;
  [key: string]: unknown;
}

export interface AuthUser {
  id?: string;
  name?: string;
  email?: string;
  role?: string;
  emailVerified?: boolean;
  token?: string | boolean;
  verified?: boolean;
  appRole?: string;
  organizationRole?: string | null;
  permission?: string | null;
  permissions?: PermissionFlags;
  session?: AuthSession;
  requiresOrganizationSetup?: boolean;
  organizations?: Array<{ id: string | number; name?: string | null }>;
  accounts?: Array<{ id?: string; name?: string; [key: string]: unknown }>;
  account_id?: string | null;
  subscription?: string | null;
  plan?: boolean;
  [key: string]: unknown;
}

export interface AuthContextValue {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  refreshSession: () => void;
  signin: (res?: unknown) => Promise<void>;
  signout: () => Promise<void>;
  update: (data: Record<string, unknown>) => void;
  globalPermissions: Record<string, PermissionFlags>;
  permission: PermissionFlags | null;
  isHydratingUser: boolean;
  hasBootstrappedSession: boolean;
  pendingInvitationError: string | null;
  clearPendingInvitationError: () => void;
}

export const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);
